import React from 'react';
import { Dropdown } from '../../Dropdown/Dropdown';
import { Button } from '../../../index'; // eslint-disable-next-line no-unused-vars

const Filter = ({
  filterList,
  selectedFilter,
  setSelectedFilter
}) => {
  const onSelectFilter = filter => {
    setSelectedFilter(filter);
  };

  return /*#__PURE__*/React.createElement(Dropdown, {
    className: "chart__filter",
    label: "selectedFilter"
  }, /*#__PURE__*/React.createElement("div", {
    className: "chart__filter-items"
  }, filterList.map(filter => {
    return /*#__PURE__*/React.createElement(Button, {
      className: "chart__filter-item",
      version: "Monochrome",
      onClick: () => onSelectFilter(filter),
      key: filter,
      label: filter
    });
  })));
};

export default Filter;